
























import { computed, defineComponent } from '@vue/composition-api';
import LoadingIcon from '@/components/UI/LoadingIcon.vue';
import { useStore } from '@/store';

export default defineComponent({
    name: 'VehicleImage',
    components: { LoadingIcon },
    props: {
        photo: { type: String, required: true },
        url: { type: String, required: true },
        id: { type: Number, required: true },
        index: { type: Number, required: true }
    },
    setup () {
        const store = useStore();
        const isLoading = computed(() => store.state.fetchingVehicleData);
        return { isLoading };
    }
});
